import { CreateBase, EditBase, Form } from "ra-core";
import { Card, CardContent } from "@/components/ui/card";

import { FormToolbar } from "../layout/FormToolbar";
import { PartnerInputs } from "./PartnerInputs";

const PartnerForm = ({
  defaultValues,
}: {
  defaultValues?: Record<string, unknown>;
}) => (
  <div className="mt-2 flex lg:mr-80">
    <div className="flex-1">
      <Form defaultValues={defaultValues}>
        <Card>
          <CardContent>
            <PartnerInputs />
            <FormToolbar />
          </CardContent>
        </Card>
      </Form>
    </div>
  </div>
);

export const PartnerCreate = () => (
  <CreateBase redirect="show">
    <PartnerForm defaultValues={{ category: "staff", custom_fields: {} }} />
  </CreateBase>
);

export const PartnerEdit = () => (
  <EditBase redirect="show">
    <PartnerForm />
  </EditBase>
);
